// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"c1792d1c","151":"921268c8","541":"32f24049","626":"470f4318","880":"e680c745","945":"fc32f292"}[chunkId] + ".chunk.css";
};